"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollegeWiseAgendaTemplates_MD = exports.CollegeWiseAgendaTemplates = exports.AgendaTemplates_MD_V2 = exports.AgendaTemplates_V2 = exports.AgendaTemplates_MD = exports.AgendaTemplates = void 0;
const bdsa_strategist_1 = require("./bdsa-strategist");
const canada_strategist_1 = require("./canada-strategist");
const eu_strategist_1 = require("./eu-strategist");
const canada_strategist_v2_1 = require("./canada-strategist-v2");
const eu_strategist_v2_1 = require("./eu-strategist-v2");
const foundations_strategist_1 = require("./foundations-strategist");
const gsa_strategist_1 = require("./gsa-strategist");
const rise_strategist_1 = require("./rise-strategist");
const ssm_1 = require("./ssm");
const uk_strategist_1 = require("./uk-strategist");
const us_strategist_1 = require("./us-strategist");
const uk_strategist_v2_1 = require("./uk-strategist-v2");
const us_strategist_v2_1 = require("./us-strategist-v2");
const fao_1 = require("./fao");
const ecl_1 = require("./ecl");
const indigo_1 = require("./indigo");
const cw_strategist_1 = require("./cw-strategist");
const cw_tutor_1 = require("./cw-tutor");
exports.AgendaTemplates = {
    SSM: ssm_1.SSM_TEMPLATES,
    'UK Strategist': uk_strategist_1.UK_STRATEGIST_TEMPLATES,
    'EU Strategist': eu_strategist_1.EU_STRATEGIST_TEMPLATES,
    'Foundations Strategist': foundations_strategist_1.FOUNDATION_STRATEGIST_TEMPLATES,
    'Canada Strategist': canada_strategist_1.CANADA_STRATEGIST_TEMPLATES,
    'Rise Strategist': rise_strategist_1.RISE_STRATEGIST_TEMPLATES,
    'BDSA Strategist': bdsa_strategist_1.BDSA_STRATEGIST_TEMPLATES,
    'GSA Strategist': gsa_strategist_1.GSA_STRATEGIST_TEMPLATES,
    'US Strategist': us_strategist_1.US_STRATEGIST_TEMPLATES,
    FAO: fao_1.FAO_TEMPLATES,
    Other: {
        Other: [
            {
                listStart: 1,
                type: 'p',
                children: [
                    {
                        text: 'N/A',
                    },
                ],
                listStyleType: 'disc',
                indent: 1,
            },
        ],
    },
};
exports.AgendaTemplates_MD = {
    SSM: ssm_1.SSM_TEMPLATES_MD,
    'UK Strategist': uk_strategist_1.UK_STRATEGIST_TEMPLATES_MD,
    'EU Strategist': eu_strategist_1.EU_STRATEGIST_TEMPLATES_MD,
    'Foundations Strategist': foundations_strategist_1.FOUNDATION_STRATEGIST_TEMPLATES_MD,
    'Canada Strategist': canada_strategist_1.CANADA_STRATEGIST_TEMPLATES_MD,
    'Rise Strategist': rise_strategist_1.RISE_STRATEGIST_TEMPLATES_MD,
    'BDSA Strategist': bdsa_strategist_1.BDSA_STRATEGIST_TEMPLATES_MD,
    'GSA Strategist': gsa_strategist_1.GSA_STRATEGIST_TEMPLATES_MD,
    'US Strategist': us_strategist_1.US_STRATEGIST_TEMPLATES_MD,
    Other: {
        Other: '* N/A',
    },
};
exports.AgendaTemplates_V2 = {
    'SSM Meeting': ssm_1.SSM_TEMPLATES,
    'US Strategy Meeting': us_strategist_v2_1.US_STRATEGIST_TEMPLATES,
    'UK Strategy Meeting': uk_strategist_v2_1.UK_STRATEGIST_TEMPLATES,
    'EU Strategy Meeting': eu_strategist_v2_1.EU_STRATEGIST_TEMPLATES,
    'Canada Strategy Meeting': canada_strategist_v2_1.CANADA_STRATEGIST_TEMPLATES,
    'Foundations Strategy Meeting': foundations_strategist_1.FOUNDATION_STRATEGIST_TEMPLATES,
    'Rise Strategy Meeting': rise_strategist_1.RISE_STRATEGIST_TEMPLATES,
    'BDSA Strategy Meeting': bdsa_strategist_1.BDSA_STRATEGIST_TEMPLATES,
    'GSA Strategy Meeting': gsa_strategist_1.GSA_STRATEGIST_TEMPLATES,
    'FAO Meeting': fao_1.FAO_TEMPLATES,
    'Capstone Meeting': ecl_1.ECL_TEMPLATES,
    'Indigo Explorer': indigo_1.INDIGO_EXPLORER_TEMPLATES,
    'Indigo Researcher': indigo_1.INDIGO_RESEARCHER_TEMPLATES,
    'Indigo Innovator': indigo_1.INDIGO_INNOVATOR_TEMPLATES,
    Other: {
        Other: [
            {
                listStart: 1,
                type: 'p',
                children: [
                    {
                        text: 'N/A',
                    },
                ],
                listStyleType: 'disc',
                indent: 1,
            },
        ],
    },
};
exports.AgendaTemplates_MD_V2 = {
    'SSM Meeting': ssm_1.SSM_TEMPLATES_MD,
    'US Strategy Meeting': us_strategist_v2_1.US_STRATEGIST_TEMPLATES_MD,
    'UK Strategy Meeting': uk_strategist_v2_1.UK_STRATEGIST_TEMPLATES_MD,
    'EU Strategy Meeting': eu_strategist_v2_1.EU_STRATEGIST_TEMPLATES_MD,
    'Canada Strategy Meeting': canada_strategist_v2_1.CANADA_STRATEGIST_TEMPLATES_MD,
    'Foundations Strategy Meeting': foundations_strategist_1.FOUNDATION_STRATEGIST_TEMPLATES_MD,
    'Rise Strategy Meeting': rise_strategist_1.RISE_STRATEGIST_TEMPLATES_MD,
    'BDSA Strategy Meeting': bdsa_strategist_1.BDSA_STRATEGIST_TEMPLATES_MD,
    'GSA Strategy Meeting': gsa_strategist_1.GSA_STRATEGIST_TEMPLATES_MD,
    Other: {
        Other: '* N/A',
    },
};
exports.CollegeWiseAgendaTemplates = {
    'Counselor Meeting': cw_strategist_1.CW_STRATEGIST_TEMPLATES,
    'Tutor Meeting': cw_tutor_1.CW_TUTOR_TEMPLATES,
};
exports.CollegeWiseAgendaTemplates_MD = {
    'Counselor Meeting': cw_strategist_1.CW_STRATEGIST_TEMPLATES_MD,
    'Tutor Meeting': cw_tutor_1.CW_TUTOR_TEMPLATES_MD,
};
//# sourceMappingURL=index.js.map